import { useEffect, useState } from "react"
import { CompetitionSeasonTeamStatsStandingFlat } from "../../../../types/competitionSeasonTeamStats"
import { CompetitionSeasonTeamStandingOld } from "@components/Competition/CompetitionSeasonTeamStandingOld"
import { CompetitionSeasonSelector } from "../CompetitionSeasonSelector/CompetitionSeasonSelector"
import { LocalizedSeason } from "types/season"
import { Col, Row } from "react-bootstrap"
import Select from "@components/UI/Select/Select"
import style from "./style.module.scss"

export function CompetitionSeasonTeamStandings({
  competitionCalciocomSlug,
  seasonCalciocomSlug,
  teamStandings,
  seasons,
  headerTitle,
  showHeader = true,
}: {
  competitionCalciocomSlug: string
  seasonCalciocomSlug: string
  teamStandings: CompetitionSeasonTeamStatsStandingFlat[]
  headerTitle?: string | null
  showHeader?: boolean
  seasons: LocalizedSeason[]
}) {
  const goalAndAssistStandings = [
    ...teamStandings.filter(
      (teamStanding) => teamStanding.parameter.code.includes("GOL") && teamStanding.parameter.code !== "GOL_S",
    ),
    ...teamStandings.filter((teamStanding) => teamStanding.parameter.code.includes("ASS")),
  ]

  const passStandings = [
    ...teamStandings.filter((teamStanding) => teamStanding.parameter.code.includes("PAS")),
    ...teamStandings.filter((teamStanding) => teamStanding.parameter.code.includes("CRS")),
  ]
  const duelStandings = teamStandings.filter((teamStanding) => teamStanding.parameter.code.includes("DUL"))
  const cardStandings = teamStandings.filter((teamStanding) => teamStanding.parameter.code.includes("CRT"))
  const dribblingStandings = teamStandings.filter((teamStanding) => teamStanding.parameter.code.includes("DRB"))
  const shotStandings = teamStandings.filter((teamStanding) => teamStanding.parameter.code.includes("TIR"))

  const goalkeeperStandings = teamStandings.filter(
    (teamStanding) =>
      teamStanding.parameter.code === "RIG_P" ||
      teamStanding.parameter.code.includes("PRT") ||
      teamStanding.parameter.code === "GOL_S" ||
      teamStanding.parameter.code === "USC",
  )

  const otherStandings = teamStandings.filter(
    (teamStanding) =>
      !["RIG_P", "USC"].includes(teamStanding.parameter.code) &&
      !teamStanding.parameter.code.includes("TIR") &&
      !teamStanding.parameter.code.includes("PRT") &&
      !teamStanding.parameter.code.includes("DRB") &&
      !teamStanding.parameter.code.includes("CRT") &&
      !teamStanding.parameter.code.includes("DUL") &&
      !teamStanding.parameter.code.includes("CRS") &&
      !teamStanding.parameter.code.includes("PAS") &&
      !teamStanding.parameter.code.includes("ASS_V") &&
      !teamStanding.parameter.code.includes("GOL"),
  )

  const options = [
    {
      name: "Gol e Assist",
      values: goalAndAssistStandings,
    },
    {
      name: "Passaggi",
      values: passStandings,
    },
    {
      name: "Tiri",
      values: shotStandings,
    },
    {
      name: "Cartellini",
      values: cardStandings,
    },
    {
      name: "Duelli",
      values: duelStandings,
    },
    {
      name: "Dribbling",
      values: dribblingStandings,
    },
    {
      name: "Portieri",
      values: goalkeeperStandings,
    },
    {
      name: "Altro",
      values: otherStandings,
    },
  ]
  const [firstOption, setFirstOption] = useState<string>(options[0].name)
  const [secondOptions, setSecondOptions] = useState<CompetitionSeasonTeamStatsStandingFlat[]>(options[0].values!)
  const [selectedStanding, setSelectedStanding] = useState<CompetitionSeasonTeamStatsStandingFlat>(secondOptions[0])
  useEffect(() => {
    setFirstOption(options[0].name)
    setSecondOptions(options[0].values!)
    setSelectedStanding(options[0].values![0])
  }, [teamStandings])

  const handleChangeFirstOption = (e: number | string) => {
    setFirstOption(e as string)
    const result = options.find((param) => param.name === e)
    if (result) {
      setSecondOptions(result.values)
      setSelectedStanding(result.values[0])
    }
  }

  const handleChangeSecondOption = (e: number | string) => {
    const result = secondOptions.find((param) => param.parameter.code === e)
    if (result) {
      setSelectedStanding(result)
    }
  }

  return (
    <>
      <Row className={style.competitionSeasonTeamStandingsContainer}>
        <Col xs={12} sm={12} md={12} lg={4} xl={4}>
          <CompetitionSeasonSelector
            competitionCalciocomSlug={competitionCalciocomSlug}
            seasonCalciocomSlug={seasonCalciocomSlug}
            seasons={seasons}
            page={"statistiche-squadre"}
          />
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} xl={4} className={style.selectWrapper}>
          <Select
            onChange={handleChangeFirstOption}
            value={firstOption}
            options={options.map((param) => ({ value: param.name, label: param.name }))}
          />
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} xl={4} className={style.selectWrapper}>
          {selectedStanding && (
            <Select
              onChange={handleChangeSecondOption}
              value={selectedStanding.parameter.code}
              options={secondOptions.map((param) => ({ value: param.parameter.code, label: param.parameter.name }))}
            />
          )}
        </Col>
      </Row>
      <div>
        {teamStandings.length > 0 ? (
          <CompetitionSeasonTeamStandingOld
            competitionCalciocomSlug={competitionCalciocomSlug}
            seasonCalciocomSlug={seasonCalciocomSlug}
            teamStandings={
              secondOptions.find((o) => o.parameter.code === selectedStanding.parameter.code)?.standing || []
            }
            headerTitle={null}
            unitMeasurement={
              secondOptions.find((o) => o.parameter.code === selectedStanding.parameter.code)?.parameter
                ?.unitMeasurement
            }
          />
        ) : (
          <span>Classifiche non disponibili</span>
        )}
      </div>
    </>
  )
}
